import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdSenderVerificationTrackingDomainsCacheKeys: AllRouteEndpoints[] = [];

export const companiesCompanyIdSenderVerificationTrackingDomains =
  "/companies/:company_id/sender_verification/tracking_domains";
